import { useReducer } from "react"

const initialState = { name: "", email: "" }
function reducer(state, action) {
    switch (action.type) {
        case "SET_NAME":
        return { ...state, name: action.payload }
        case "SET_EMAIL":
        return { ...state, email: action.payload }
        default:
        return state
    }
}
export default function FormReducer() {
    const [state, dispatch] = useReducer(reducer, initialState)
    return (
        <form>
        <input
            value={state.name}
            onChange={(e) => dispatch({ type: "SET_NAME", payload:
            e.target.value })}
            placeholder="Imię"
        />
        <input
            value={state.email}
            onChange={(e) => dispatch({ type: "SET_EMAIL", payload:
            e.target.value })}
            placeholder="Email"
        />
        <p>{JSON.stringify(state)}</p>
        </form>
    )
}